module.exports = __webpack_public_path__ + "static/media/142.60db186e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/142.jpg
// module id = 940
// module chunks = 0